import React from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {toast, ToastContainer} from 'react-toastify';
import {withStyles} from '@material-ui/core/styles';
import {ForgotPassword} from "aws-amplify-react";
import {I18n} from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import AmplifyTheme from '../../themes/AmplifyTheme';
import CssBaseline from '@material-ui/core/CssBaseline';

import Logo from "../../assets/img/logo-square-on-white.svg";

class CustomForgotPassword extends ForgotPassword
{
    constructor(props)
    {
        super(props);
        this.send = this.send.bind(this);
        this.submit = this.submit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        this._validAuthStates = ['forgotPassword'];
        this.state = {delivery: null, password: '', code: ''};
    }

    handleInputChange(event)
    {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        switch (name)
        {
            case 'username':
                this.setState({username: value});
                break;
            case 'password':
                this.setState({password: value})
                break;
            case 'code':
                this.setState({code: value})
                break;
            default:
                break;
        }
    }

    send(e)
    {
        e.preventDefault();
        const {authData = {}} = this.props;
        const username = this.state.username.toLowerCase() || authData.username;
        if (!Auth || typeof Auth.forgotPassword !== 'function')
        {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        Auth.forgotPassword(username)
            .then(data =>
            {
                this.setState({delivery: data.CodeDeliveryDetails});
            })
            .catch((err) =>
            {
                switch (err.code)
                {
                    case 'LimitExceededException':
                        toast.error("Sie haben zu oft versucht Ihr Passwort zurücksetzen zu lassen. Bitte kontaktieren Sie den Support.")
                        break;
                    default:
                        toast.error("Es ist ein unbekannter Fehler aufgetreten. Bitte kontaktieren Sie den Support.")
                        break;
                }
            });
    }

    submit(e)
    {
        e.preventDefault();
        const {authData = {}} = this.props;
        const username = this.state.username.toLowerCase() || authData.username;

        if (!Auth || typeof Auth.forgotPasswordSubmit !== 'function')
        {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        Auth.forgotPasswordSubmit(username, this.state.code, this.state.password)
            .then(data =>
            {
                this.changeState('signIn');
                this.setState({delivery: null});
            })
            .catch((err) =>
            {
                switch (err.code)
                {
                    case 'InvalidParameterException':
                        toast.error("Das Kennwort entspricht nicht den Richtlinien (mindestens 8 Zeichen).")
                        break;
                    case 'CodeMismatchException':
                        toast.error("Der Bestätigungscode ist ungültig. Bitte versuchen Sie es erneut oder fordern Sie einen neuen Bestätigungscode an.")
                        break;
                    default:
                        toast.error("Es ist ein unbekannter Fehler aufgetreten. Bitte kontaktieren Sie den Support.")
                        break;
                }
            });
    }

    sendView()
    {
        return (
            <div>
                <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="username">{I18n.get('E-Mail Adresse')}</InputLabel>
                    <Input id="username" key="username" name="username" autoComplete="email" autoFocus autoCorrect="off" autoCapitalize="off" spellCheck="false"
                           onChange={this.handleInputChange}/>
                </FormControl>
            </div>
        );
    }

    submitView()
    {
        return (
            <div>
                <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="code">{I18n.get('Bestätigungscode')}</InputLabel>
                    <Input id="code" key="code" name="code" autoComplete="code" autoFocus onChange={this.handleInputChange}/>
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="password">{I18n.get('New Password')}</InputLabel>
                    <Input id="password" key="password" type="password" name="password" autoComplete="password" onChange={this.handleInputChange}/>
                    {(this.state.password === "" || this.state.password.length < 8) &&
                        <FormHelperText id="component-error-text">Das Passwort muss mindestens 8 Zeichen lang sein.</FormHelperText>
                    }
                </FormControl>
            </div>
        );
    }

    showComponent()
    {
        const {classes, authData = {}} = this.props;
        return (
            <MuiThemeProvider theme={AmplifyTheme}>
                <CssBaseline/>
                <div className={classes.main}>
                    <ToastContainer/>
                    <Paper className={classes.paper}>
                        <img src={Logo} width="200" height="200" alt="QRsticker logo"/>
                        <Typography component="h1" variant="h5" className={classes.title}>
                            {I18n.get('Reset your password')}
                        </Typography>
                        <hr/>

                        {this.state.delivery || authData.username ?
                            <Typography variant="caption">
                                Wir haben Ihnen einen Bestätigungscode per E-Mail geschickt. Bitte schauen Sie in Ihrem E-Mail Postfach nach.
                            </Typography>
                            :
                            <Typography variant="caption">
                                Um Ihr Passwort zurücksetzen zu lassen senden wir Ihnen einen Bestätigungscode per E-Mail zu.
                            </Typography>
                        }
                        <form className={classes.form} onSubmit={this.state.delivery || authData.username ? this.submit : this.send}>
                            <div>
                                {this.state.delivery || authData.username ? this.submitView() : this.sendView()}
                            </div>
                            <div>
                                {this.state.delivery || authData.username ?
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        className={classes.submit}
                                        disabled={this.state.password.length < 8}>
                                        {I18n.get('Passwort setzen')}
                                    </Button>
                                    :
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        className={classes.submit}>
                                        {I18n.get('Bestätigungscode anfordern')}
                                    </Button>
                                }
                            </div>
                            <div>
                                {this.state.delivery || authData.username ?
                                    <Button
                                        type="button"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit}
                                        onClick={this.send}>
                                        {I18n.get('Neuen Code anfordern')}
                                    </Button>
                                    :
                                    <Button
                                        type="button"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit}
                                        onClick={() => this.changeState('signIn')}>
                                        {I18n.get('Back to Sign In')}
                                    </Button>
                                }
                            </div>
                        </form>
                    </Paper>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default withStyles(AmplifyTheme)(CustomForgotPassword);
